import AdminUserPage from './AdminUserPage';

const Maud = () => <AdminUserPage user="Maud" />;

export default Maud;
